module.exports = __webpack_public_path__ + "static/img/patent3.jpg";